








































































































import { Component, Vue } from "vue-property-decorator";
@Component({
    name: "ButtonSix"
})
export default class ButtonSix extends Vue { }
